<template>
  <div class="m-banner">
    <div class="top"></div>
    <a
      :href="extras.kvlink.model"
      v-if="
        extras.banner.display == 1 &&
        extras.banner.src &&
        extras.kvlink &&
        extras.kvlink.display == 1
      "
    >
      <div
        class="banner"
        :style="{
          backgroundImage:
            'url(' +
            (extras.banner.display === 1
              ? extras.banner.src
                ? extras.banner.src
                : imgUrlObj.wap.banner
              : '') +
            ')',
          backgroundColor:
            extras.bannerBackgroundColor && extras.bannerBackgroundColor
              ? extras.bannerBackgroundColor.color
              : '',
          backgroundSize: '100% auto',
        }"
      >
        <div
          class="title"
          v-html="seminarInfo.title"
          :style="{
            display:
              extras.titlefont && extras.titlefont.display == 1 ? '' : 'none',
            color: extras.titlefont.color ? extras.titlefont.color : '',
          }"
        ></div>
        <div
          class="time2"
          :style="{
            color: extras.meetingTime.color ? extras.meetingTime.color : '',
            backgroundColor: extras.meetingTime.bg ? extras.meetingTime.bg : '',
          }"
          v-if="seminarInfo.startTime && extras.meetingTime.display == 1"
        >
          {{ handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime) }}
        </div>
        <div
          class="time2"
          :style="{
            display:
              extras.meetingAddress && extras.meetingAddress.display == 1
                ? 'block'
                : 'none',
            color: extras.meetingAddress && extras.meetingAddress.color,
            backgroundColor: extras.meetingAddress.bg
              ? extras.meetingAddress.bg
              : '',
          }"
          v-if="seminarInfo.address"
        >
          {{ seminarInfo.address }}
        </div>
        <div
          class="remainder"
          :style="{
            display:
              extras.meetingCountDown && extras.meetingCountDown.display == 1
                ? 'block'
                : 'none',
            color: extras.meetingCountDown && extras.meetingCountDown.color,
            backgroundColor: extras.meetingCountDown.bg
              ? extras.meetingCountDown.bg
              : '',
          }"
        >
          <span v-if="seminarStatus === 3">进行中</span>
          <span v-if="seminarStatus === 4">已结束</span>
          <span v-if="seminarStatus === 1"
            >距离会议开始<span
              class="remainder-num"
              :style="{
                color:
                  extras.meetingCountDownNum &&
                  extras.meetingCountDownNum.color,
              }"
              >{{ remainder.days }}</span
            >天<span
              class="remainder-num"
              :style="{
                color:
                  extras.meetingCountDownNum &&
                  extras.meetingCountDownNum.color,
              }"
              >{{ remainder.hours }}</span
            >时<span
              class="remainder-num"
              :style="{
                color:
                  extras.meetingCountDownNum &&
                  extras.meetingCountDownNum.color,
              }"
              >{{ remainder.minutes }}</span
            >分</span
          >
        </div>
        <div
          class="seminar-btn"
          v-if="
            !isFrozen &&
            seminarStatus !== 4 &&
            (signUpUrl || memberInfo.signUpStatus != 0) &&
            (isSetting == 1 ||
              (isSetting == 0 &&
                memberInfo.signUpStatus == 0 &&
                !isLogin &&
                seminarInfo.isOpenMember != 0 &&
                signUpUrl) ||
              (isSetting == 0 &&
                memberInfo.signUpStatus == 0 &&
                (isLogin || seminarInfo.isOpenMember == 0) &&
                signUpUrl)) &&
            extraItem.extras('noSignUp.display', 1)
          "
        >
          <div
            class="btn"
            v-if="isSetting == 1"
            :style="{
              backgroundColor: extras.signUpBg && extras.signUpBg.color,
            }"
          >
            {{ extras.noSignUp.model || "立即报名" }}
          </div>
          <div
            class="btn"
            v-show="
              isSetting == 0 &&
              memberInfo.signUpStatus == 0 &&
              !isLogin &&
              seminarInfo.isOpenMember != 0 &&
              signUpUrl
            "
            :style="{
              backgroundColor: extras.signUpBg && extras.signUpBg.color,
            }"
            @click="goto('login')"
          >
            {{ extras.noSignUp.model || "立即报名" }}
          </div>
          <div
            v-if="
              isSetting == 0 &&
              memberInfo.signUpStatus == 0 &&
              (isLogin || seminarInfo.isOpenMember == 0) &&
              signUpUrl
            "
            :style="{
              backgroundColor: extras.signUpBg && extras.signUpBg.color,
            }"
            class="btn"
            @click="goto('newLogin')"
          >
            {{ extras.noSignUp.model || "立即报名" }}
          </div>
        </div>
        <div
          class="seminar-btn"
          v-if="
            !isFrozen &&
            seminarStatus !== 4 &&
            (signUpUrl || memberInfo.signUpStatus != 0) &&
            isSetting == 0 &&
            memberInfo.signUpStatus == 1 &&
            extraItem.extras('checkPending.display', 1)
          "
        >
          <div
            class="btn audit"
            @click="goto('signUp')"
            :style="{
              backgroundColor: extras.signUpBg && extras.signUpBg.color,
            }"
          >
            {{ extras.checkPending.model || "审核中..." }}
          </div>
        </div>
        <div
          class="seminar-btn"
          v-show="extraItem.extras('approve.display', 1)"
          v-if="
            !isFrozen &&
            seminarStatus !== 4 &&
            (signUpUrl || memberInfo.signUpStatus != 0) &&
            isSetting == 0 &&
            (memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3)
          "
        >
          <div
            class="btn registered"
            @click="goto('signUp')"
            :style="{
              backgroundColor: extras.signUpBg && extras.signUpBg.color,
            }"
          >
            {{ extras.approve.model || "报名成功" }}
          </div>
        </div>
        <div
          class="seminar-btn"
          v-if="
            !isFrozen &&
            seminarStatus !== 4 &&
            (signUpUrl || memberInfo.signUpStatus != 0) &&
            isSetting == 0 &&
            memberInfo.signUpStatus == 4 &&
            extraItem.extras('reject.display', 1)
          "
        >
          <div
            class="btn refuse"
            @click="goto('signUp')"
            :style="{
              backgroundColor: extras.signUpBg && extras.signUpBg.color,
            }"
          >
            {{ extras.reject.model || "拒绝报名" }}
          </div>
        </div>
      </div>
    </a>
    <div
      v-if="extras.kvlink == undefined || extras.kvlink.display == 0"
      class="banner"
      :style="{
        backgroundImage:
          'url(' +
          (extras.banner.display === 1
            ? extras.banner.src
              ? extras.banner.src
              : imgUrlObj.wap.banner
            : '') +
          ')',
        backgroundColor:
          extras.bannerBackgroundColor && extras.bannerBackgroundColor
            ? extras.bannerBackgroundColor.color
            : '',
        backgroundSize: '100% auto',
      }"
    >
      <div
        class="title"
        v-html="seminarInfo.title"
        :style="{
          display:
            extras.titlefont && extras.titlefont.display == 1 ? '' : 'none',
          color: extras.titlefont.color ? extras.titlefont.color : '',
        }"
      ></div>
      <div
        class="time2"
        :style="{
          color: extras.meetingTime.color ? extras.meetingTime.color : '',
          backgroundColor: extras.meetingTime.bg ? extras.meetingTime.bg : '',
        }"
        v-if="seminarInfo.startTime && extras.meetingTime.display == 1"
      >
        {{ handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime) }}
      </div>
      <div
        class="time2"
        :style="{
          display:
            extras.meetingAddress && extras.meetingAddress.display == 1
              ? 'block'
              : 'none',
          color: extras.meetingAddress && extras.meetingAddress.color,
          backgroundColor: extras.meetingAddress.bg
            ? extras.meetingAddress.bg
            : '',
        }"
        v-if="seminarInfo.address"
      >
        {{ seminarInfo.address }}
      </div>
      <div
        class="remainder"
        :style="{
          display:
            extras.meetingCountDown && extras.meetingCountDown.display == 1
              ? 'block'
              : 'none',
          color: extras.meetingCountDown && extras.meetingCountDown.color,
          backgroundColor: extras.meetingCountDown.bg
            ? extras.meetingCountDown.bg
            : '',
        }"
      >
        <span v-if="seminarStatus === 3">进行中</span>
        <span v-if="seminarStatus === 4">已结束</span>
        <span v-if="seminarStatus === 1"
          >距离会议开始<span
            class="remainder-num"
            :style="{
              color:
                extras.meetingCountDownNum && extras.meetingCountDownNum.color,
            }"
            >{{ remainder.days }}</span
          >天<span
            class="remainder-num"
            :style="{
              color:
                extras.meetingCountDownNum && extras.meetingCountDownNum.color,
            }"
            >{{ remainder.hours }}</span
          >时<span
            class="remainder-num"
            :style="{
              color:
                extras.meetingCountDownNum && extras.meetingCountDownNum.color,
            }"
            >{{ remainder.minutes }}</span
          >分</span
        >
      </div>
      <div
        class="seminar-btn"
        v-if="
          !isFrozen &&
          seminarStatus !== 4 &&
          (signUpUrl || memberInfo.signUpStatus != 0) &&
          (isSetting == 1 ||
            (isSetting == 0 &&
              memberInfo.signUpStatus == 0 &&
              !isLogin &&
              seminarInfo.isOpenMember != 0 &&
              signUpUrl) ||
            (isSetting == 0 &&
              memberInfo.signUpStatus == 0 &&
              (isLogin || seminarInfo.isOpenMember == 0) &&
              signUpUrl)) &&
          extraItem.extras('noSignUp.display', 1)
        "
      >
        <div
          class="btn"
          v-if="isSetting == 1"
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
        >
          {{ extras.noSignUp.model || "立即报名" }}
        </div>
        <div
          class="btn"
          v-show="
            isSetting == 0 &&
            memberInfo.signUpStatus == 0 &&
            !isLogin &&
            seminarInfo.isOpenMember != 0 &&
            signUpUrl
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          @click="goto('login')"
        >
          {{ extras.noSignUp.model || "立即报名" }}
        </div>
        <div
          v-if="
            isSetting == 0 &&
            memberInfo.signUpStatus == 0 &&
            (isLogin || seminarInfo.isOpenMember == 0) &&
            signUpUrl
          "
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
          class="btn"
          @click="goto('signUp')"
        >
          {{ extras.noSignUp.model || "立即报名" }}
        </div>
      </div>
      <div
        class="seminar-btn"
        v-if="
          !isFrozen &&
          seminarStatus !== 4 &&
          (signUpUrl || memberInfo.signUpStatus != 0) &&
          isSetting == 0 &&
          memberInfo.signUpStatus == 1 &&
          extraItem.extras('checkPending.display', 1)
        "
      >
        <div
          class="btn audit"
          @click="goto('signUp')"
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
        >
          {{ extras.checkPending.model || "审核中..." }}
        </div>
      </div>
      <div
        class="seminar-btn"
        v-show="extraItem.extras('approve.display', 1)"
        v-if="
          !isFrozen &&
          seminarStatus !== 4 &&
          (signUpUrl || memberInfo.signUpStatus != 0) &&
          isSetting == 0 &&
          (memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3)
        "
      >
        <div
          class="btn registered"
          @click="goto('signUp')"
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
        >
          {{ extras.approve.model || "报名成功" }}
        </div>
      </div>
      <div
        class="seminar-btn"
        v-if="
          !isFrozen &&
          seminarStatus !== 4 &&
          (signUpUrl || memberInfo.signUpStatus != 0) &&
          isSetting == 0 &&
          memberInfo.signUpStatus == 4 &&
          extraItem.extras('reject.display', 1)
        "
      >
        <div
          class="btn refuse"
          @click="goto('signUp')"
          :style="{
            backgroundColor: extras.signUpBg && extras.signUpBg.color,
          }"
        >
          {{ extras.reject.model || "拒绝报名" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, URLS } from "fire-wind-water";
import moment from "moment";
import { handleTimeStampToDateTime } from "@/utils/utils";
import Api from "@/service/api";
import { goto } from "../../mixins/goto";

export default {
  name: "Banner",
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    signUpStatus: Number,
    loginUrl: String,
    registerUrl: String,
    isFrozen: Boolean,
    extras: {
      banner: {
        src: "",
      },
      backgroundColor: {
        value: "#135ed8",
      },
    },
  },
  data: function () {
    return {
      isLogin: false,
      signUpUrl: "",
      isSetting: 0,
      seminarStatus: 0, //0 未开始 1 已经开始 2 已经结束
      imgUrlObj: {
        wap: {
          banner: require("@/assets/images/banner.jpg"),
        },
      },
      remainder: { days: 0, hours: 0, minutes: 0 },
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
    $subscriber.subscribe("config-loaded", (res) => {
      this.extras = res;
    });
  },
  mounted() {
    console.log("banner2-extras", this.extras);
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    let signUpUrl = this.seminarInfo.signUp;
    const tc = URLS.getURL("tc");
    if (tc) {
      signUpUrl = `${signUpUrl}&tc=${tc}`;
    }
    this.signUpUrl = signUpUrl;
    // if (smarket.urlParams.tc != null) {
    //   signUpUrl = signUpUrl + "&tc=" + smarket.urlParams.tc;
    // }
    if (this.seminarInfo && this.seminarInfo.startTime) {
      Api.getServerTime().subscribe((res) => {
        let startTime = this.seminarInfo.startTime * 1000;
        let endTime = this.seminarInfo.endTime * 1000;
        let currentTime = res.content * 1000;
        let diffTime = endTime;
        this.seminarStatus = 3;
        if (currentTime < startTime) {
          this.seminarStatus = 1;
          diffTime = startTime;
        } else if (currentTime > endTime) {
          this.seminarStatus = 4;
          return;
        }
        let dif = moment(diffTime).diff(res.content * 1000, "minutes");
        let days = Math.floor(dif / (24 * 60));
        let hours = Math.floor(dif / 60) - days * 24;
        let minutes = dif % 60;
        this.remainder = {
          days,
          hours,
          minutes,
        };
      });
    } else {
      this.remainder = "会议准备中";
    }
  },
  methods: {
    goto(s) {
      let url = "";
      switch (s) {
        case "newLogin":
          url = goto.newLogin(
            URLS.updateSearchParam("openSign", "1", window.location.href),
            true
          );
          window.$sk.goto(url);
          break;
        case "login":
          goto.loginToSignUp();
          break;
        case "signUp":
          goto.signUp();
          break;
      }
    },
    gotoUrl: (url) => {
      const markCode = URLS.getURL("markCode");
      const markType = URLS.getURL("markType");
      let u = markCode
        ? URLS.updateSearchParam("markCode", markCode, url)
        : url;
      u = markType ? URLS.updateSearchParam("markType", markType, u) : u;
      window.$sk.goto(u);
    },
    handleDiffTimeForNow: (seminarInfo) => {
      if (seminarInfo && seminarInfo.startTime) {
        let startTime = seminarInfo.startTime * 1000;
        let endTime = seminarInfo.endTime * 1000;
        let currentTime = moment().unix() * 1000;
        let seminarStatus = "结束";
        let diffTime = endTime;
        if (currentTime < startTime) {
          seminarStatus = "开始";
          diffTime = startTime;
        } else if (currentTime > endTime) {
          this.seminarStatus = 4;
          return "会议已经结束";
        }
        let dif = moment(diffTime).diff(moment(), "minutes");
        let days = Math.floor(dif / (24 * 60));
        let hours = Math.floor(dif / 60) - days * 24;
        let minutes = dif % 60;
        return `距离大会${seminarStatus}还有<span class="seminar-remainder-num">${days}</span>天<span class="seminar-remainder-num">${hours}</span>小时<span class="seminar-remainder-num">${minutes}</span>分`;
      }
      return "会议准备中";
    },
    handleTimeStamps: (startTimeStamp, endTimeStamp) => {
      let startTimeYear = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY");
      let startDate = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日 HH:mm"
          ) +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "MM月DD日")
        );
      } else {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY年MM月DD日")
        );
      }
    },
  },
};
</script>

<style></style>
